var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 77.5,
    viewBox: "0 0 95 77.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 95,
    height: 77.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 95,
    height: 77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 38.544,
    height: 42.581,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(-15.034 -136.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_3",
    "data-name": "Component 3 \\u2013 3",
    transform: "translate(15.034 136.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 95,
    height: 77,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Component_5_1",
    "data-name": "Component 5 \\u2013 1",
    transform: "translate(43.262 151.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M21.661,41.461l-1.9,1a1.044,1.044,0,0,1-.973,0l-1.9-1C6.434,35.969,0,25.836,0,14.87v-6.7A1.039,1.039,0,0,1,.922,7.135,7.589,7.589,0,0,0,7.843.915,1.052,1.052,0,0,1,8.88,0H29.663A1.051,1.051,0,0,1,30.7.915a7.591,7.591,0,0,0,6.922,6.22,1.04,1.04,0,0,1,.922,1.037v6.7c0,10.966-6.434,21.1-16.883,26.591",
    fill: "#e1e6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M39.591,7.134A7.587,7.587,0,0,1,32.671.915,1.053,1.053,0,0,0,31.633,0H30.218c.2,4.521,3.425,7.727,6.911,8.095a1.039,1.039,0,0,1,.922,1.038v6.7c0,10.966-6.434,21.1-16.883,26.591l-.219.115a1.038,1.038,0,0,0,.779-.076l1.9-1c10.449-5.491,16.883-15.625,16.883-26.59v-6.7a1.04,1.04,0,0,0-.922-1.038",
    transform: "translate(-1.97)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M18.884,39.075a29.945,29.945,0,0,1-11.4-10.35,25.949,25.949,0,0,1-4.1-13.9v-3.8a1.34,1.34,0,0,1,.846-1.248,11.783,11.783,0,0,0,6.335-5.823,1.339,1.339,0,0,1,1.212-.759H27.4a1.341,1.341,0,0,1,1.212.759,11.778,11.778,0,0,0,6.335,5.823A1.342,1.342,0,0,1,35.8,11.02v3.8a25.941,25.941,0,0,1-4.1,13.9,29.952,29.952,0,0,1-11.4,10.35l-.079.042a1.349,1.349,0,0,1-1.253,0Z",
    transform: "translate(-0.318 -0.3)",
    fill: "#889cd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M36.634,9.771l-.066-.027L36.459,9.7c-.063-.025-.124-.053-.186-.079l-.107-.046-.2-.09-.089-.041L35.6,9.307,35.581,9.3c-.086-.043-.17-.088-.255-.133l-.09-.049-.183-.1-.1-.058-.171-.1-.1-.061-.177-.111-.085-.054c-.08-.053-.159-.105-.236-.159l-.018-.012c-.084-.058-.168-.118-.25-.178l-.076-.057q-.086-.063-.169-.128l-.09-.069L33.43,7.9l-.088-.072q-.079-.064-.155-.13c-.026-.023-.053-.044-.079-.068-.063-.055-.126-.111-.188-.168l-.039-.034c-.074-.069-.148-.138-.22-.208L32.6,7.158c-.052-.051-.1-.1-.154-.153l-.076-.079c-.045-.047-.091-.094-.135-.142L32.157,6.7c-.044-.048-.089-.1-.132-.147l-.071-.08c-.051-.059-.1-.119-.151-.178l-.043-.053c-.063-.077-.127-.156-.188-.235-.016-.02-.032-.041-.047-.062-.045-.059-.091-.119-.135-.178l-.063-.087-.113-.16c-.022-.031-.043-.062-.064-.093-.037-.053-.073-.108-.109-.162l-.059-.091c-.04-.062-.079-.124-.117-.187l-.043-.069c-.053-.085-.1-.172-.152-.258L30.639,4.6c-.039-.069-.077-.138-.114-.207L30.477,4.3c-.031-.058-.061-.117-.091-.176l-.05-.1L30.3,3.948a1.338,1.338,0,0,0-1.21-.759H21.272V39.271a1.342,1.342,0,0,0,.626-.155l.079-.042a29.931,29.931,0,0,0,11.4-10.35,25.931,25.931,0,0,0,4.1-13.9v-3.8a1.342,1.342,0,0,0-.845-1.249",
    transform: "translate(-2 -0.3)",
    fill: "#546bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M36.634,9.771l-.066-.027L36.459,9.7c-.063-.025-.124-.053-.186-.079l-.107-.046-.2-.09-.089-.041L35.6,9.307,35.581,9.3c-.086-.043-.17-.088-.255-.133l-.09-.049-.183-.1-.1-.058-.171-.1-.1-.061-.177-.111-.085-.054c-.08-.053-.159-.105-.236-.159l-.018-.012c-.084-.058-.168-.118-.25-.178l-.076-.057q-.086-.063-.169-.128l-.09-.069L33.43,7.9l-.088-.072q-.079-.064-.155-.13c-.026-.023-.053-.044-.079-.068-.063-.055-.126-.111-.188-.168l-.039-.034c-.074-.069-.148-.138-.22-.208L32.6,7.158c-.052-.051-.1-.1-.154-.153l-.076-.079c-.045-.047-.091-.094-.135-.142L32.157,6.7c-.044-.048-.089-.1-.132-.147l-.071-.08c-.051-.059-.1-.119-.151-.178l-.043-.053c-.063-.077-.127-.156-.188-.235-.016-.02-.032-.041-.047-.062-.045-.059-.091-.119-.135-.178l-.063-.087-.113-.16c-.022-.031-.043-.062-.064-.093-.037-.053-.073-.108-.109-.162l-.059-.091c-.04-.062-.079-.124-.117-.187l-.043-.069c-.053-.086-.1-.172-.152-.259-.011-.018-.021-.036-.031-.055-.039-.069-.077-.138-.114-.207L30.477,4.3l-.091-.176-.05-.1L30.3,3.948a1.338,1.338,0,0,0-1.21-.759H26.924a12.011,12.011,0,0,1,.95,1.434c.014.025.025.052.038.078s.034.067.05.1c.03.059.06.118.091.176l.048.093c.037.07.075.139.114.208.011.018.02.036.031.055.05.087.1.173.152.258.014.024.028.046.043.069.038.063.077.125.117.187l.059.091c.036.054.072.109.109.162.021.032.043.063.064.094.037.053.075.106.113.159l.063.087.135.179c.015.02.031.041.047.061.062.08.124.158.188.236l.043.052c.05.06.1.12.151.178l.071.08c.043.05.088.1.132.148l.077.083c.044.048.09.1.135.142l.077.079c.05.052.1.1.153.153l.062.062c.072.07.146.139.22.207l.039.034c.063.057.125.113.188.169l.079.067c.052.044.1.088.155.13l.088.072.154.123.09.07.169.127.077.057c.082.06.165.12.249.178l.018.012c.078.054.157.107.236.159l.086.054c.058.038.117.075.176.111l.1.061.171.1.1.058.183.1.09.049c.084.045.169.09.255.133l.021.011.279.137.089.041c.065.03.13.061.2.09l.107.046c.062.027.123.053.186.079l.11.044.065.027a1.342,1.342,0,0,1,.846,1.249v3.8a25.934,25.934,0,0,1-4.106,13.9,31.948,31.948,0,0,1-9.679,9.836v.035a1.342,1.342,0,0,0,.626-.155l.079-.042a29.931,29.931,0,0,0,11.4-10.35,25.933,25.933,0,0,0,4.1-13.9v-3.8a1.342,1.342,0,0,0-.845-1.249",
    transform: "translate(-2 -0.3)",
    fill: "#253d8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16.3,17.223V12.886a4.415,4.415,0,1,1,8.83,0v4.337h1.248V12.886a5.662,5.662,0,1,0-11.325,0v4.337Z",
    transform: "translate(-1.415 -0.679)",
    fill: "#515a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M27.538,28.835H13.3a1.359,1.359,0,0,1-1.359-1.36V18.544a1.359,1.359,0,0,1,1.359-1.36H27.538a1.36,1.36,0,0,1,1.36,1.36v8.931a1.36,1.36,0,0,1-1.36,1.36",
    transform: "translate(-1.122 -1.616)",
    fill: "#636a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M28.9,17.184H26.439a1.36,1.36,0,0,1,1.36,1.36v8.931a1.36,1.36,0,0,1-1.36,1.36H28.9a1.36,1.36,0,0,0,1.36-1.36V18.544a1.36,1.36,0,0,0-1.36-1.36",
    transform: "translate(-2.486 -1.616)",
    fill: "#515a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M22.608,22.717a1.461,1.461,0,1,0-2.085,1.32v1.776a.624.624,0,0,0,1.248,0V24.037a1.46,1.46,0,0,0,.837-1.32",
    transform: "translate(-1.851 -1.999)",
    fill: "#f1f1f1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.621eea3380c88464b7029476c3f58c68.svg";
export { ForwardRef as ReactComponent };